
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-24-security_svg-a)","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1 3.775v7.637A12.31 12.31 0 009.219 22.88l1.121.414a3.365 3.365 0 002.32 0l1.121-.414A12.312 12.312 0 0022 11.412V3.775a1.532 1.532 0 00-.934-1.406A24.237 24.237 0 0011.5.5a24.237 24.237 0 00-9.566 1.869A1.533 1.533 0 001 3.775v0z"}}),_c('path',{attrs:{"d":"M5 8.7a1.3 1.3 0 112.6 0 1.85 1.85 0 01-.406 1.157L5 12.6h2.6m4.55-1.95h-2.6V10a2.6 2.6 0 012.6-2.6v5.2m2.6-5.2v5.2m0-2.6h1.95a1.3 1.3 0 011.3 1.3v1.3"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-24-security_svg-a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    